import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import api from "@/lib/api";

export default function Creators() {
  const [creators, setCreators] = useState([]);
  useEffect(() => { window.scrollTo(0, 0); api.get("/creators").then(({ data }) => setCreators(data.creators)); }, []);

  return (
    <div>
      <section className="bg-[#0A0A0A] text-white py-24 text-center">
        <span className="over text-[0.62rem] text-[#D4AF37]">La maison Cagole Chic</span>
        <h1 className="font-display text-5xl lg:text-6xl font-light mt-4">Nos créateurs</h1>
        <p className="text-neutral-400 mt-5 max-w-xl mx-auto px-4">Des talents indépendants, choisis pour leur singularité et réunis au sein d'une même enseigne.</p>
      </section>

      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 py-16 space-y-20">
        {creators.map((c, idx) => (
          <div key={c.id} className={`grid lg:grid-cols-2 gap-10 lg:gap-16 items-center ${idx % 2 ? "lg:[direction:rtl]" : ""}`}>
            <div className="lg:[direction:ltr] aspect-[4/3] bg-[#0A0A0A] overflow-hidden" data-testid={`creator-card-${c.id}`}>
              {c.portrait_url ? <img src={c.portrait_url} alt={c.brand_name} className="w-full h-full object-cover opacity-90" />
                : <div className="w-full h-full flex items-center justify-center"><span className="font-display text-4xl text-white tracking-wider">{c.brand_name}</span></div>}
            </div>
            <div className="lg:[direction:ltr]">
              <span className="over text-[0.62rem] text-[#D4AF37]">{c.main_category} · {c.city}, {c.country}</span>
              <h2 className="font-display text-4xl mt-3">{c.brand_name}</h2>
              <p className="text-neutral-600 mt-4 leading-relaxed">{c.universe}</p>
              <div className="flex gap-3 mt-6">
                {c.preview?.slice(0, 3).map((p) => (
                  <Link key={p.id} to={`/produit/${p.id}`} className="w-24 aspect-[3/4] overflow-hidden bg-neutral-100">
                    <img src={p.images?.[0]} alt={p.name} className="w-full h-full object-cover hover:scale-105 transition-transform duration-500" />
                  </Link>
                ))}
              </div>
              <Link to={`/createur/${c.id}`} className="over text-[0.65rem] mt-7 inline-flex items-center gap-2 link-underline" data-testid={`creator-discover-${c.id}`}>
                Voir ses créations ({c.product_count}) <ArrowRight size={14} />
              </Link>
            </div>
          </div>
        ))}
      </div>

      <section className="max-w-3xl mx-auto px-4 pb-24 text-center">
        <div className="border border-[#D4AF37]/40 py-14 px-8">
          <h2 className="font-display text-3xl">Votre univers mérite d'être découvert</h2>
          <Link to="/devenir-createur" className="btn btn-magenta mt-6">Postuler comme créateur</Link>
        </div>
      </section>
    </div>
  );
}
